/** 설립일. 사업자 정보와 About 의 운영 연차가 같은 값을 봐요. */
export const FOUNDED_AT = "2022-03-28";

/**
 * MVP 구현에서 끝나지 않고 **배포·운영까지 마친** 누적 프로젝트 건수.
 *
 * 다른 KPI 와 달리 이 숫자는 `portfolio.ts` 에서 파생되지 않아요 — 포트폴리오에는 자사 제품만
 * 싣고 고객사 프로젝트는 NDA 등으로 공개하지 않기 때문이에요. 그래서 회사가 직접 관리하는
 * 값이고, 여기가 유일한 원본이에요(화면 여러 곳에 손으로 적어두면 금방 어긋나요).
 *
 * **광고 문구의 근거가 되는 수치라 실제 수행 건수를 넘지 않게 유지해요.** 표시광고법상
 * 실적 과장은 거짓·과장 광고예요. 늘었을 때만 올리고, 근거를 댈 수 있는 값으로 둬요.
 */
export const COMPLETED_PROJECTS = 30;

/** Single source of truth for legally-required business info (About + Footer). */
export const BUSINESS_INFO: { label: string; value: string }[] = [
  { label: "상호", value: "주식회사 디체인커넥트" },
  { label: "대표자", value: "오미숙" },
  { label: "사업자등록번호", value: "463-81-02611" },
  // 전자상거래법상 표시 의무 항목이에요. 신고증 원본: 제2022-서울서초-1328호 (서초구청, 2022-09-02 신고).
  { label: "통신판매업신고", value: "제2022-서울서초-1328호" },
  { label: "소재지", value: "서울특별시 서초구 서초중앙로 200, 10-505" },
  { label: "설립", value: FOUNDED_AT },
  { label: "연락처", value: "contact@dchain-connect.com" },
];

export default BUSINESS_INFO;
